export default __webpack_public_path__ + "static/media/qrcode-site-1920w.2fbdd4f7.png";